module.exports = __webpack_public_path__ + "h5/img/logo_q.b4be323d.png";